<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    v-model="drawer"
    :dark="barColor !== 'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)'"
    :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl"
    :src="barImage"
    mobile-breakpoint="960"
    app
    width="260"
    v-bind="$attrs"
  >
    <template v-slot:img="props">
      <v-img
        :gradient="`to bottom, ${barColor}`"
        v-bind="props"
      />
    </template>

    <v-divider class="mb-1" />

    <v-list
      nav
    >
      <v-row
        justify="space-around"
      >
        <v-avatar
          size="62"
        >
          <v-img
            contain
            :src="logoImage"
            alt="GarnetLogo"
          />
        </v-avatar>
      </v-row>
      <v-list-item-content>
        <v-list-item-title
          class="display-1 text-center"
          v-text="profile.title"
        />
      </v-list-item-content>
    </v-list>

    <v-divider class="mb-2" />

    <v-list
      expand
      nav
      dense
    >
      <!-- *** START DASHBOARD *** -->
      <v-list-item
        v-if="this.userFeatures.some(x => x.featureTitle === 'dashboard')"
        link
        to="/"
      >
        <v-list-item-icon>
          <i class="fad fa-tachometer fa-lg fa-fw" />
        </v-list-item-icon>
        <v-list-item-title
          v-text="this.$t('dashboard')"
        ></v-list-item-title>
      </v-list-item>
      <!-- *** END DASHBOARD *** -->

      <!-- *** START USERS *** -->
      <v-list-group
        v-if="this.userFeatures.some(x => x.featureTitle === 'users')"
        sub-group
        no-action
      >
        <template v-slot:activator>
          <v-list-item>
<!--            <v-badge-->
<!--              color="red"-->
<!--              icon="fas fa-bell"-->
<!--              inline-->
<!--            >-->
            <v-list-item-icon>
              <i class="fad fa-users fa-lg fa-fw mt-1" />
            </v-list-item-icon>
            <v-list-item-title>{{ $t('users') }}</v-list-item-title>
<!--            </v-badge>-->
          </v-list-item>
        </template>

        <v-list-item
          link
          to="/users/operations"
          v-if="this.userFeatures.some(x => x.featureTitle === 'users/operations')"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('operations')"
          ></v-list-item-title>
        </v-list-item>

        <v-list-item
          link
          to="/users/category"
          v-if="this.userFeatures.some(x => x.featureTitle === 'users/category')"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('category')"
          ></v-list-item-title>
        </v-list-item>

<!--        <v-list-item-->
<!--          link-->
<!--          to="/users/attributes"-->
<!--        >-->
<!--          <v-list-item-title-->
<!--            class="ms-6"-->
<!--            v-text="this.$t('attributes')"-->
<!--          ></v-list-item-title>-->
<!--        </v-list-item>-->

        <v-list-item
          link
          to="/users/settings"
          v-if="this.userFeatures.some(x => x.featureTitle === 'users/settings')"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('settings')"
          ></v-list-item-title>
        </v-list-item>

      </v-list-group>
      <!-- *** END USERS *** -->

      <!-- *** START PAGES *** -->
      <v-list-group
        v-if="this.userFeatures.some(x => x.featureTitle === 'pages')"
        sub-group
        no-action
      >
        <template v-slot:activator>
          <v-list-item>
            <v-list-item-icon>
              <i class="fad fa-file-alt fa-lg fa-fw mt-1" />
            </v-list-item-icon>
            <v-list-item-title>{{ $t('pages') }}</v-list-item-title>
          </v-list-item>
        </template>

        <v-list-item
          v-if="this.userFeatures.some(x => x.featureTitle === 'pages/operations')"
          link
          to="/pages/operations"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('operations')"
          ></v-list-item-title>
        </v-list-item>

        <v-list-item
          v-if="this.userFeatures.some(x => x.featureTitle === 'pages/settings')"
          link
          to="/pages/settings"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('settings')"
          ></v-list-item-title>
        </v-list-item>

      </v-list-group>
      <!-- *** END PAGES *** -->

      <!-- *** START PRODOCTS *** -->
      <v-list-group
        v-if="this.userFeatures.some(x => x.featureTitle === 'products')"
        sub-group
        no-action
      >
        <template v-slot:activator>
          <v-list-item>
            <v-list-item-icon>
              <i class="fad fa-boxes fa-lg fa-fw mt-1" />
            </v-list-item-icon>
            <v-list-item-title>{{ $t('products') }}</v-list-item-title>
          </v-list-item>
        </template>

        <v-list-item
          v-if="this.userFeatures.some(x => x.featureTitle === 'products/operations')"
          link
          to="/products/operations"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('operations')"
          ></v-list-item-title>
        </v-list-item>

        <v-list-item
          v-if="this.userFeatures.some(x => x.featureTitle === 'products/category')"
          link
          to="/products/category"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('category')"
          ></v-list-item-title>
        </v-list-item>

        <v-list-item
          v-if="this.userFeatures.some(x => x.featureTitle === 'products/attributes')"
          link
          to="/products/attributes"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('attributes')"
          ></v-list-item-title>
        </v-list-item>

        <v-list-item
          v-if="this.userFeatures.some(x => x.featureTitle === 'products/settings')"
          link
          to="/products/settings"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('settings')"
          ></v-list-item-title>
        </v-list-item>

      </v-list-group>
      <!-- *** END PRODOCTS *** -->

      <!-- *** START STORAGE *** -->
      <v-list-group
        v-if="this.userFeatures.some(x => x.featureTitle === 'storage')"
        sub-group
        no-action
      >
        <template v-slot:activator>
          <v-list-item>
            <v-list-item-icon>
              <i class="fad fa-pallet-alt fa-lg fa-fw mt-1" />
            </v-list-item-icon>
            <v-list-item-title>{{ $t('storage') }}</v-list-item-title>
          </v-list-item>
        </template>

        <v-list-item
          link
          to="/storage/operations"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('operations')"
          ></v-list-item-title>
        </v-list-item>

        <v-list-item
          link
          to="/storage/category"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('category')"
          ></v-list-item-title>
        </v-list-item>

        <v-list-item
          link
          to="/storage/attributes"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('attributes')"
          ></v-list-item-title>
        </v-list-item>

        <v-list-item
          link
          to="/storage/settings"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('settings')"
          ></v-list-item-title>
        </v-list-item>

      </v-list-group>
      <!-- *** END STORAGE *** -->

      <!-- *** START COURSES *** -->
      <v-list-group
        sub-group
        no-action
        v-if="this.userFeatures.some(x => x.featureTitle === 'courses')"
      >
        <template v-slot:activator>
          <v-list-item>
            <v-list-item-icon>
              <i class="fad fa-users-class fa-lg fa-fw mt-1" />
            </v-list-item-icon>
            <v-list-item-title>{{ $t('courses') }}</v-list-item-title>
          </v-list-item>
        </template>

        <v-list-item
          link
          to="/courses/operations"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('operations')"
          ></v-list-item-title>
        </v-list-item>

        <v-list-item
          link
          to="/courses/category"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('category')"
          ></v-list-item-title>
        </v-list-item>

        <v-list-item
          link
          to="/courses/attributes"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('attributes')"
          ></v-list-item-title>
        </v-list-item>

        <v-list-item
          link
          to="/courses/settings"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('settings')"
          ></v-list-item-title>
        </v-list-item>

      </v-list-group>
      <!-- *** END COURSES *** -->

      <!-- *** START BLOG *** -->
      <v-list-group
        sub-group
        no-action
        v-if="this.userFeatures.some(x => x.featureTitle === 'blog')"
      >
        <template v-slot:activator>
          <v-list-item>
            <v-list-item-icon>
              <i class="fad fa-bullhorn fa-lg fa-fw mt-1" />
            </v-list-item-icon>
            <v-list-item-title>{{ $t('blog') }}</v-list-item-title>
          </v-list-item>
        </template>

        <v-list-item
          link
          to="/blog/operations"
          v-if="this.userFeatures.some(x => x.featureTitle === 'blog/operations')"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('operations')"
          ></v-list-item-title>
        </v-list-item>

        <v-list-item
          link
          to="/blog/category"
          v-if="this.userFeatures.some(x => x.featureTitle === 'blog/category')"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('category')"
          ></v-list-item-title>
        </v-list-item>

        <v-list-item
          link
          to="/blog/settings"
          v-if="this.userFeatures.some(x => x.featureTitle === 'blog/settings')"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('settings')"
          ></v-list-item-title>
        </v-list-item>

      </v-list-group>
      <!-- *** END BLOG *** -->

      <!-- *** START TICKETS *** -->
      <v-list-group
        sub-group
        no-action
        v-if="this.userFeatures.some(x => x.featureTitle === 'tickets')"
      >
        <template v-slot:activator>
          <v-list-item>
            <v-list-item-icon>
              <i class="fad fa-ticket fa-lg fa-fw mt-1" />
            </v-list-item-icon>
            <v-list-item-title>{{ $t('tickets') }}</v-list-item-title>
          </v-list-item>
        </template>

        <v-list-item
          link
          to="/tickets/operations"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('operations')"
          ></v-list-item-title>
        </v-list-item>

        <v-list-item
          link
          to="/tickets/category"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('category')"
          ></v-list-item-title>
        </v-list-item>

        <v-list-item
          link
          to="/tickets/attributes"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('attributes')"
          ></v-list-item-title>
        </v-list-item>

        <v-list-item
          link
          to="/tickets/settings"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('settings')"
          ></v-list-item-title>
        </v-list-item>

      </v-list-group>
      <!-- *** END TICKETS *** -->

      <!-- *** START LINKS *** -->
      <v-list-group
        sub-group
        no-action
        v-if="this.userFeatures.some(x => x.featureTitle === 'links')"
      >
        <template v-slot:activator>
          <v-list-item>
            <v-list-item-icon>
              <i class="fad fa-link fa-lg fa-fw mt-1" />
            </v-list-item-icon>
            <v-list-item-title>{{ $t('links') }}</v-list-item-title>
          </v-list-item>
        </template>

        <v-list-item
          link
          to="/links/operations"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('operations')"
          ></v-list-item-title>
        </v-list-item>

        <v-list-item
          link
          to="/links/category"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('category')"
          ></v-list-item-title>
        </v-list-item>

        <v-list-item
          link
          to="/links/attributes"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('attributes')"
          ></v-list-item-title>
        </v-list-item>

        <v-list-item
          link
          to="/links/settings"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('settings')"
          ></v-list-item-title>
        </v-list-item>

      </v-list-group>
      <!-- *** END LINKS *** -->

      <!-- *** START FROMS *** -->
      <v-list-group
        v-if="this.userFeatures.some(x => x.featureTitle === 'forms')"
        sub-group
        no-action
      >
        <template v-slot:activator>
          <v-list-item>
            <v-list-item-icon>
              <i class="fad fa-question-square fa-lg fa-fw mt-1" />
            </v-list-item-icon>
            <v-list-item-title>{{ $t('forms') }}</v-list-item-title>
          </v-list-item>
        </template>

        <v-list-item
          v-if="this.userFeatures.some(x => x.featureTitle === 'forms/operations')"
          link
          to="/forms/operations"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('operations')"
          ></v-list-item-title>
        </v-list-item>

        <v-list-item
          v-if="this.userFeatures.some(x => x.featureTitle === 'forms/results')"
          link
          to="/forms/results"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('results')"
          ></v-list-item-title>
        </v-list-item>

        <v-list-item
          v-if="this.userFeatures.some(x => x.featureTitle === 'forms/settings')"
          link
          to="/forms/settings"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('settings')"
          ></v-list-item-title>
        </v-list-item>

      </v-list-group>
      <!-- *** END FROMS *** -->

      <!-- *** START QUESTIONS *** -->
      <v-list-group
        v-if="this.userFeatures.some(x => x.featureTitle === 'questions')"
        sub-group
        no-action
      >
        <template v-slot:activator>
          <v-list-item>
            <v-list-item-icon>
              <i class="fad fa-ballot-check fa-lg fa-fw mt-1" />
            </v-list-item-icon>
            <v-list-item-title>{{ $t('questions') }}</v-list-item-title>
          </v-list-item>
        </template>

        <v-list-item
          v-if="this.userFeatures.some(x => x.featureTitle === 'questions/operations')"
          link
          to="/questions/operations"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('operations')"
          ></v-list-item-title>
        </v-list-item>

        <v-list-item
          v-if="this.userFeatures.some(x => x.featureTitle === 'questions/category')"
          link
          to="/questions/category"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('category')"
          ></v-list-item-title>
        </v-list-item>

        <v-list-item
          v-if="this.userFeatures.some(x => x.featureTitle === 'questions/results')"
          link
          to="/questions/results"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('results')"
          ></v-list-item-title>
        </v-list-item>

        <v-list-item
          v-if="this.userFeatures.some(x => x.featureTitle === 'questions/settings')"
          link
          to="/questions/settings"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('settings')"
          ></v-list-item-title>
        </v-list-item>

      </v-list-group>
      <!-- *** END QUESTIONS *** -->

      <!-- *** START STORE *** -->
      <v-list-group
        sub-group
        no-action
        v-if="this.userFeatures.some(x => x.featureTitle === 'store')"
      >
        <template v-slot:activator>
          <v-list-item>
            <v-list-item-icon>
              <i class="fad fa-store fa-lg fa-fw mt-1" />
            </v-list-item-icon>
            <v-list-item-title>{{ $t('store') }}</v-list-item-title>
          </v-list-item>
        </template>

        <v-list-item
          link
          to="/store/operations"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('operations')"
          ></v-list-item-title>
        </v-list-item>

        <v-list-item
          link
          to="/store/settings"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('settings')"
          ></v-list-item-title>
        </v-list-item>

      </v-list-group>
      <!-- *** END STORE *** -->

      <!-- *** START ACCOUNTING  *** -->
      <v-list-group
        sub-group
        no-action
        v-if="this.userFeatures.some(x => x.featureTitle === 'accounting')"
      >
        <template v-slot:activator>
          <v-list-item>
            <v-list-item-icon>
              <i class="fad fa-file-invoice-dollar fa-lg fa-fw mt-1" />
            </v-list-item-icon>
            <v-list-item-title>{{ $t('accounting') }}</v-list-item-title>
          </v-list-item>
        </template>

        <v-list-item
          link
          to="/accounting/operations"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('operations')"
          ></v-list-item-title>
        </v-list-item>

        <v-list-item
          link
          to="/accounting/category"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('category')"
          ></v-list-item-title>
        </v-list-item>

        <v-list-item
          link
          to="/accounting/attributes"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('attributes')"
          ></v-list-item-title>
        </v-list-item>

        <v-list-item
          link
          to="/accounting/settings"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('settings')"
          ></v-list-item-title>
        </v-list-item>

      </v-list-group>
      <!-- *** END ACCOUNTING *** -->

      <!-- *** START SLIDERS *** -->
      <v-list-group
        sub-group
        no-action
        v-if="this.userFeatures.some(x => x.featureTitle === 'sliders')"
      >
        <template v-slot:activator>
          <v-list-item>
            <v-list-item-icon>
              <i class="fad fa-images fa-lg fa-fw mt-1" />
            </v-list-item-icon>
            <v-list-item-title>{{ $t('sliders') }}</v-list-item-title>
          </v-list-item>
        </template>

        <v-list-item
          link
          to="/sliders/operations"
          v-if="this.userFeatures.some(x => x.featureTitle === 'sliders/operations')"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('operations')"
          ></v-list-item-title>
        </v-list-item>

      </v-list-group>
      <!-- *** END SLIDERS *** -->

      <!-- *** START POLLS *** -->
      <v-list-group
        sub-group
        no-action
        v-if="this.userFeatures.some(x => x.featureTitle === 'polls')"
      >
        <template v-slot:activator>
          <v-list-item>
            <v-list-item-icon>
              <i class="fad fa-poll-h fa-lg fa-fw mt-1" />
            </v-list-item-icon>
            <v-list-item-title>{{ $t('polls') }}</v-list-item-title>
          </v-list-item>
        </template>

        <v-list-item
          link
          to="/polls/operations"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('operations')"
          ></v-list-item-title>
        </v-list-item>

        <v-list-item
          link
          to="/polls/category"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('category')"
          ></v-list-item-title>
        </v-list-item>

        <v-list-item
          link
          to="/polls/attributes"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('attributes')"
          ></v-list-item-title>
        </v-list-item>

        <v-list-item
          link
          to="/polls/settings"
        >
          <v-list-item-title
            class="ms-6"
            v-text="this.$t('settings')"
          ></v-list-item-title>
        </v-list-item>

      </v-list-group>
      <!-- *** END POLLS *** -->

      <!-- *** START REPORTS *** -->
      <v-list-item
        link
        to="/reports"
        v-if="this.userFeatures.some(x => x.featureTitle === 'reports')"
      >
        <v-list-item-icon>
          <i class="fad fa-analytics fa-lg fa-fw mt-1" />
        </v-list-item-icon>
        <v-list-item-title
          v-text="this.$t('reports')"
        ></v-list-item-title>
      </v-list-item>
      <!-- *** END REPORTS *** -->

      <!-- *** START SETTINGS *** -->
      <v-list-item
        link
        to="/settings"
        v-if="this.userFeatures.some(x => x.featureTitle === 'settings')"
      >
        <v-list-item-icon>
          <i class="fad fa-cogs fa-lg mt-1" />
        </v-list-item-icon>
        <v-list-item-title
          v-text="this.$t('settings')"
        ></v-list-item-title>
      </v-list-item>
      <!-- *** END SETTINGS *** -->

    </v-list>

<!--    <template v-slot:append>-->
<!--      <base-item-->
<!--        :item="{-->
<!--          title: $t('upgrade'),-->
<!--          icon: 'mdi-package-up',-->
<!--          to: '/upgrade',-->
<!--        }"-->
<!--      />-->
<!--    </template>-->
  </v-navigation-drawer>
</template>

<script>
  import {
    mapState,
  } from 'vuex'

  export default {
    name: 'DashboardCoreDrawer',

    props: {
      expandOnHover: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      activeItem: 1,
      features: [],
      userFeatures: [],
    }),
    async created () {
      await this.getUserFeature()
    },
    computed: {
      ...mapState(['barColor', 'barImage', 'logoImage']),
      drawer: {
        get () {
          return this.$store.state.drawer
        },
        set (val) {
          this.$store.commit('SET_DRAWER', val)
        },
      },
      profile () {
        return {
          avatar: true,
          title: this.$t('garnetCMS'),
        }
      },
    },
    methods: {
      getUserFeature () {
        this.$http.post('userFeature/showByUser', {
          user_id: 1,
        }).then(
          response => {
            this.userFeatures = response.data.UserFeature
          },
          error => {
            if (error.data.code === 2001) {
              this.$router.push('/login')
            } else {
              console.log(error)
            }
          }).catch(error => {
          console.log(error)
        })
      },
    },
  }
</script>

<style lang="sass">
  @import '~vuetify/src/styles/tools/_rtl.sass'

  #core-navigation-drawer
    .v-badge__wrapper
      .v-icon
        font-size: 10px
    .v-list-group__header.v-list-item--active:before
      opacity: .24
    .v-list-item__icon
      margin-left: 16px
    .v-list-group--sub-group
      .v-list-item
        +ltr()
          padding-left: 8px

        +rtl()
          padding-right: 8px

      .v-list-group__header
        +ltr()
          padding-left: 0

        +rtl()
          padding-right: 0
        .v-list-group__header__prepend-icon
          order: 2

          +ltr()
            margin-right: 0px

          +rtl()
            margin-left: 0px
</style>
